import {
  Grid, Hidden,
  List, ListItem, ListItemText, makeStyles, Menu, MenuItem, Typography,
  ListSubheader,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import React, { useContext } from 'react';
import FiltersContext from '../../contexts/FiltersContext';
import colors from '../../modules/colors';

function Filters() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [currentMenu, setCurrentMenu] = React.useState(null);
  const {
    settingType, setSettingType, acceptSubsidies, setAcceptSubsidies,
  } = useContext(FiltersContext);

  const classes = makeStyles((theme) => ({
    button: {
      backgroundColor: colors.blue,
      color: colors.white,
      borderRadius: 4,
      marginRight: theme.spacing(1),
      maxWidth: '40%',
      '&:hover': {
        backgroundColor: colors.lightBlue,
        boxShadow: 'none',
      },
      [theme.breakpoints.down('sm')]: {
        maxWidth: '45%',
      },
    },
  }))();

  const handleFilterClick = (menu) => (event) => {
    setAnchorEl(event.currentTarget);
    setCurrentMenu(menu);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeSettingType = (value) => () => {
    setSettingType(value);
    setCurrentMenu(null);
  };

  const handleChangeAcceptSubsidies = (value) => () => {
    setAcceptSubsidies(value);
    setCurrentMenu(null);
  };

  return (
    <>
      <Grid container direction="row" justify="center" alignItems="center">
        <Grid item xs={12} md={10}>
          <List
            component="nav"
            aria-label="Filters"
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              padding: 0,
            }}
            subheader={(
              <Hidden smDown>
                <ListSubheader component="div" id="nested-list-subheader">
                  Filter By:
                </ListSubheader>
              </Hidden>
            )}
          >
            <ListItem
              className={classes.button}
              button
              dense
              aria-haspopup="true"
              aria-controls="lock-menu"

              onClick={handleFilterClick('settingTypeMenu')}
            >
              <ListItemText
                primary="Setting Type"
                secondary={(
                  <Typography style={{ color: '#fff' }} variant="caption">
                    {settingType}
                  </Typography>
                )}
              />
              <ExpandMoreIcon />
            </ListItem>
            <ListItem
              className={classes.button}
              button
              dense
              aria-haspopup="true"
              aria-controls="lock-menu"

              onClick={handleFilterClick('acceptSubsidiesMenu')}
            >
              <ListItemText
                primary="Accept Subsidies"
                secondary={(
                  <Typography style={{ color: '#fff' }} variant="caption">
                    {acceptSubsidies}
                  </Typography>
                )}
              />
              <ExpandMoreIcon />
            </ListItem>

          </List>
        </Grid>
      </Grid>

      <Menu id="settingTypeMenu" anchorEl={anchorEl} keepMounted open={currentMenu === 'settingTypeMenu' && Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem key="All" selected={settingType === 'All'} onClick={handleChangeSettingType('All')}>
          {settingType === 'All' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;All
        </MenuItem>
        <MenuItem key="Center-based child care" selected={settingType === 'Center-based child care'} onClick={handleChangeSettingType('Center-based child care')}>
          {settingType === 'Center-based child care' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;Center-based child care
        </MenuItem>
        <MenuItem key="Family child care (FCC)" selected={settingType === 'Family child care (FCC)'} onClick={handleChangeSettingType('Family child care (FCC)')}>
          {settingType === 'Family child care (FCC)' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;Family child care (FCC)
        </MenuItem>
      </Menu>

      <Menu id="acceptSubsidiesMenu" anchorEl={anchorEl} keepMounted open={currentMenu === 'acceptSubsidiesMenu' && Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem key="Accept subsidies" selected={acceptSubsidies === 'Accept subsidies'} onClick={handleChangeAcceptSubsidies('Accept subsidies')}>
          {acceptSubsidies === 'Accept subsidies' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;Accept subsidies
        </MenuItem>
        <MenuItem key="Do not accept subsidies" selected={acceptSubsidies === 'Do not accept subsidies'} onClick={handleChangeAcceptSubsidies('Do not accept subsidies')}>
          {acceptSubsidies === 'Do not accept subsidies' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;Do not accept subsidies
        </MenuItem>
      </Menu>
    </>
  );
}

export default Filters;
